import React, { useState, useEffect, useRef } from "react";
import "./Header.css";
import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { isValidPath } from "../../utils/validation";
import { useLocation, Link } from "react-router-dom";
import IdexcelLogo from "../../assets/images/logo/IdexcelLogo.png";

export default function Header() {
  const [isNavVisible, setNavVisibility] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const nodeRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setNavVisibility(false);
      }
    };

    const handleScroll = () => {
      setIsScrolled(window.pageYOffset > 500);
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const closeMenu = () => {
    setNavVisibility(false);
    setActiveDropdown(null);
  };

  const handleNavigation = (url) => {
    if (isValidPath(url)) {
      window.location.assign(url);
    } else {
      console.warn("Invalid path:", url);
    }
  };

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <header className={`Header ${isScrolled ? "scrolled" : ""}`}>
      <Link to="/">
        <img src={IdexcelLogo} className="Logo" alt="logo" />
      </Link>

      <CSSTransition
        in={!isSmallScreen || isNavVisible}
        timeout={350}
        classNames="NavAnimation"
        unmountOnExit
        nodeRef={nodeRef}
      >
        <nav className={`Nav ${isNavVisible ? "open" : ""}`} ref={nodeRef}>
          <div
            className={`NavItem ${isScrolled ? "text-black" : ""}`}
            onClick={() => toggleDropdown("services")}
            onMouseEnter={() => toggleDropdown("services")}
            onMouseLeave={() => toggleDropdown(null)}
          >
            <span>Services</span>
            <FontAwesomeIcon
              icon={faAngleDown}
              style={{ height: "18px", marginTop: "4px" }}
            />
            {activeDropdown === "services" && (
              <div className="DropdownContent">
                <Link
                  to="/gen-ai-banking"
                  onClick={closeMenu}
                >
                  AI Banking
                </Link>
                <Link to="/enterprise-ai" onClick={closeMenu}>
                  Enterprise AI
                </Link>
                <Link to="/data-analytics" onClick={closeMenu}>
                  Data & Analytics
                </Link>
                <Link to="/next-gen-modernization" onClick={closeMenu}>
                  Next-Gen Modernization
                </Link>
                <Link to="/cloud-innovations" onClick={closeMenu}>
                  Cloud Innovations
                </Link>
                <Link to="/managed-cybersecurity" onClick={closeMenu}>
                  Managed Cybersecurity
                </Link>
              </div>
            )}
          </div>

          <div
            className={`NavItem ${isScrolled ? "text-black" : ""}`}
            onMouseEnter={() => toggleDropdown("resources")}
            onMouseLeave={() => toggleDropdown(null)}
            onClick={() => toggleDropdown("resources")}
          >
            <span>Resources</span>{" "}
            <FontAwesomeIcon
              icon={faAngleDown}
              style={{ height: "18px", marginTop: "4px" }}
            />
            {activeDropdown === "resources" && (
              <div className="DropdownContent">
                <Link to="/blog" onClick={closeMenu}>
                  Blog
                </Link>
                <Link to="/success-stories" onClick={closeMenu}>
                  Partner Story
                </Link>
                <Link to="/case-studies" onClick={closeMenu}>
                  Case Studies
                </Link>
                <Link to="/news-and-events" onClick={closeMenu}>
                  News & Events
                </Link>
                <Link to="/videos" onClick={closeMenu}>
                  Videos
                </Link>
              </div>
            )}
          </div>

          <Link
            to="/careers"
            onClick={closeMenu}
            className={isScrolled ? "text-black" : ""}
            id="careers-link"
          >
            Careers
          </Link>

          <div
            className={`NavItem ${isScrolled ? "text-black" : ""}`}
            onClick={() => toggleDropdown("about")}
            onMouseEnter={() => toggleDropdown("about")}
            onMouseLeave={() => toggleDropdown(null)}
          >
            <span>About Us</span>{" "}
            <FontAwesomeIcon
              icon={faAngleDown}
              style={{ height: "18px", marginTop: "4px" }}
            />
            {activeDropdown === "about" && (
              <div className="DropdownContent">
                <Link to="/company-overview" onClick={closeMenu}>
                  Company Overview
                </Link>
                <Link to="/our-leadership" onClick={closeMenu}>
                  Leadership Team
                </Link>
              </div>
            )}
          </div>

          <button
            size="large"
            color="header"
            onClick={() => (window.location.href = "/contact-us")}
            className={`headerbtn ${
              isScrolled ? "scrolled-headerbtn" : "transparent-headerbtn"
            }`}
          >
            Get In Touch
          </button>
        </nav>
      </CSSTransition>

      <FontAwesomeIcon
        icon={faBars}
        onClick={() => setNavVisibility(!isNavVisible)}
        className={`Burger ${isScrolled ? "Burger-black" : "Burger-white"}`}
      />
    </header>
  );
}
